import p1 from "./projectImages/p1.jpeg";
import p2 from "./projectImages/p2.jpeg";
import p3 from "./projectImages/p3.jpeg";
import p4 from "./projectImages/p4.jpeg";
import p5 from "./projectImages/p5.jpeg";
import p6 from "./projectImages/p6.jpeg";
import p7 from "./projectImages/p7.jpeg";
import p8 from "./projectImages/p8.jpeg";
import p9 from "./projectImages/p9.jpeg";
const projectList = [
  {
    id: 1,
    imgList: [p1],
    title: "Sangachal Terminal",
    desciption: "Facility Maintenance",
    previewImg: p1,
    client: "Client 1",
    location: "Baku",
    budget: "100$",
    duration: "1 months",
    status: "Completed",
  },
  {
    id: 2,
    imgList: [p2],
    title: "CTTC Training",
    desciption: "Facility Management & Maintenance.",
    previewImg: p2,
    client: "Client 2",
    location: "Baku",
    budget: "200$",
    duration: "2 months",
    status: "Completed",
    sector: "Construction",
  },
  {
    id: 3,
    imgList: [p3],
    title: "UIS",
    desciption: "Facility Management & Maintenance.",
    previewImg: p3,
    client: "Client 3",
    location: "Baku",
    budget: "1214$",
    duration: "3 months",
    status: "Completed",
    sector: "Construction",
  },
  {
    id: 4,
    imgList: [p4],
    title: "Mavi Dalğa Hotel",
    desciption: "Facility Management.",
    previewImg: p4,
    client: "Client 4",
    location: "Baku",
    budget: "400$",
    duration: "4 months",
    status: "Completed",
    sector: "Construction",
  },
  {
    id: 5,
    imgList: [p5],
    title: "Saipem",
    desciption: "HVAC",
    previewImg: p5,
    client: "Client 5",
    location: "Baku",
    budget: "400$",
    duration: "5 months",
    status: "Completed",
    sector: "Construction",
  },
  {
    id: 6,
    imgList: [p6],
    title: "Petrofac",
    desciption: "Transportation Partner, Facility Maintenance",
    previewImg: p6,
    client: "Client 6",
    location: "Baku",
    budget: "600$",
    duration: "6 months",
    status: "Completed",
    sector: "Construction",
  },
  {
    id: 7,
    imgList: [p7],
    title: "Boshelf",
    desciption: "Facility Maintenance",
    previewImg: p7,
    client: "Client 7",
    location: "Baku",
    budget: "700$",
    duration: "7 months",
    status: "Completed",
    sector: "Construction",
  },
  {
    id: 8,
    imgList: [p8],
    title: "GL",
    desciption: "Transportation Rental",
    previewImg: p8,
    client: "Client 8",
    location: "Baku",
    budget: "800$",
    duration: "8 months",
    status: "Completed",
    sector: "Construction",
  },
  {
    id: 9,
    imgList: [p9],
    title: "TISSA school",
    desciption: "Facility Maintenance",
    previewImg: p9,
    client: "Client 8",
    location: "Baku",
    budget: "800$",
    duration: "8 months",
    status: "Completed",
    sector: "Construction",
  },
];

export default projectList;
